import React, { useState, useEffect } from "react";
import "./ChooseActivityForm.css";
import { Activity, NotFound, Paginations } from "../../../../components";
import { axiosGet } from "../../../../utils/apis/api";
import { SpinnerLoading } from "../../../../components";
import dayjs from "dayjs";
import { Col, Row } from "react-bootstrap";
import { TextField, Autocomplete } from "@mui/material";
import Cookies from "js-cookie";
import { useTranslation } from "../../../../contexts/TranslationContext";
import activitiesIcon from "../../../../assets/images/packages/svg/mountain.svg";


const ChooseActivityForm = ({ url, onReturn, dates, selectedDestination }) => {
  const formattedStart = dates?.startDate
    ? dayjs(dates.startDate).format("MMM D")
    : null;
  const formattedEnd = dates?.endDate
    ? dayjs(dates.endDate).format("MMM D")
    : null;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [errorInfo, setErrorInfo] = useState(null);

  const resultsPerPage = 10;
  const { t } = useTranslation();

  const Lang = Cookies.get("preferred_language") || "en";

  const [locations, setLocations] = useState([]);
  const [hasMorelocations, setHasMorelocations] = useState(true);
  const PAGE_LIMIT = 50;

  const [toDestination, setToDestination] = useState(
    selectedDestination || null
  );

  const fetchLocations = async (
    newSearch = "",
    newStart = 0,
    append = false
  ) => {
    if (!hasMorelocations && append) return; // Stop if no more items
    try {
      const response = await axiosGet(
        `${url}/api/method/alltimes.www.api.locations`,
        {
          search: newSearch,
          start: newStart,
          limit: PAGE_LIMIT,
        }
      );

      const newItems = Array.isArray(response.result?.locations)
        ? response.result?.locations
        : []; // Ensure array
      setLocations((prevItems) =>
        append ? [...prevItems, ...newItems] : newItems
      );
      setHasMorelocations(newItems.length === PAGE_LIMIT);
    } catch (error) {
      console.error("Error fetching items:", error);
      setLocations([]); // Ensure items is always an array
    } finally {
    }
  };

  const fetchActivities = async (pageNumber = 1, destination) => {
    setLoading(true);

    try {
    const start = (pageNumber - 1) * resultsPerPage;
    let apiUrl = `${url}/api/method/alltimes.alltimes_travel.doctype.all_time_activity.all_time_activity.activity?start=${start}&limit=${resultsPerPage}`;

    if (destination) {
      let new_dest = destination.location; // ?? destination.name
      apiUrl += `&destination=${new_dest}`;
    }

    const response = await axiosGet(apiUrl);

    const result = response.result;
    setCurrentPage(result.pagination.metadata.current_page);
    setTotalPages(result.pagination.metadata.total_pages);
    setData(result.items);
    setLoading(false);
    setErrorInfo(null); // Clear error on success
    
  } catch (error) {
    setData([]); // Clear data
    setLoading(false);
    const errorCode = error.response?.status || "500";
    const errorMessage = error.response?.statusText || t("Error");
    const description =
      error.response?.data?.message ||  t("SomthingWrongPleaseTryAgain");
    setErrorInfo({ errorCode, errorMessage, description });
  } finally {
   
  }
};


  const onPageChange = (pageNumber) => {
    fetchActivities(pageNumber, toDestination);
  };

  useEffect(() => {
    fetchActivities(1, toDestination);
  }, [toDestination]);

  if (loading) {
    return (
      <div className="loading-container">
        <SpinnerLoading />
      </div>
    );
  }
  return (
    <div className="activity-form-contianer">
      <button className="hotel-form-backbtn" onClick={() => onReturn()}>
      {Lang === "ar" ? (
          <>
            {t("BackToPlan")}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 23 23"
              fill="none"
            >
              <path
                d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 23 23"
              fill="none"
            >
              <path
                d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {t("BackToPlan")}
          </>
        )}
      </button>

       <div className="component-form-title">
          <div className="component-form-title-icon">
            <img src={activitiesIcon} alt="hotel"/>
          </div>
          <div>{t("Activities")}</div>
        </div>

      <div className="activity-form-dates-nights">
        {`${formattedStart} - ${formattedEnd} ${t("In")} ${selectedDestination.location_name}`}
      </div>
      <Row style={{ alignItems: "center" }}>
        <Col xl={3} md={6}>
          <div className="activity-input-container">
            <label className="activity-input-label">{t("Destination")}</label>
            <Autocomplete
              readOnly
              dir={Lang === "ar" ? "rtl" : "ltr"}
              style={{ width: "100%" }}
              options={locations}
              value={toDestination}
              onChange={(_, value) => setToDestination(value)}
              onInputChange={(event, value, reason) => {
                if (reason === "input") {
                  fetchLocations(value);
                }
              }}
              getOptionLabel={(option) => option?.location_name || ""}
              // onFocus={() => fetchLocations("", 0, false)}
              sx={{
                ".MuiAutocomplete-inputRoot": {
                  fontSize: "12px",
                  flexDirection: Lang === "ar" ? "row-reverse" : "row",
                },
                ".MuiAutocomplete-endAdornment": {
                  left: Lang === "ar" ? "9 !important" : "unset !important",
                  right: Lang === "ar" ? "unset !important" : "9 !important",
                },
                ".MuiInputBase-input": {
                  textAlign: Lang === "ar" ? "right" : "left",
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder={t("Destination")}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      direction: Lang === "ar" ? "rtl" : "ltr",
                    },
                    sx: {
                      backgroundColor: "#FFF",
                      borderRadius: "6px",
                      padding: "9px 15px !important",
                      fontFamily: '"Dmsans400"',
                      fontSize: "14px !important",
                      fontWeight: 400,
                      letterSpacing: "0.25px",
                    },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.name}>
                  {option.location_name}
                </li>
              )}
            />
          </div>
        </Col>
      </Row>

      {data && data.length > 0 ? (
        <>
          {" "}
          <div className="activities-form">
            {data &&
              data.map((tour, index) => (
                <Activity
                  key={index}
                  item={tour}
                  duration={tour.duration}
                  title={tour.name1}
                  image={url + "/" + tour.image}
                  startDate={dates.startDate}
                  endDate={dates.endDate}
                  formattedStartDate={formattedStart}
                  formattedEndDate={formattedEnd}
                  selectedDestination={selectedDestination}
                  onReturn={onReturn}
                />
              ))}
          </div>
          <div className="d-flex justify-content-center mt-5">
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>{" "}
        </>
      ) : (
        <NotFound
          errorCode={errorInfo?.errorCode || "204"}
          errorMessage={errorInfo?.errorMessage || t("NoData")}
          description={errorInfo?.description || t("NoActivityAvailable")}
        />
      )}
    </div>
  );
};

export default ChooseActivityForm;
